import { Controller } from "@hotwired/stimulus"

// shipping-carrier-provider — flips the visible credentials block AND
// any provider-conditional fields (e.g. the Environment dropdown) when
// the user picks a different carrier provider (Shippo / UPS / FedEx).
//
// Replaces an inline DOMContentLoaded script that worked on a full
// page load but never wired up under Turbo navigations (DOMContentLoaded
// fires once per real page load, not per Turbo nav). Stimulus auto-
// connects whenever the controller's element enters the DOM, including
// after Turbo swaps it in, so the toggle behaves consistently.
//
// Targets:
//   select    — the <select> for the provider
//   section   — one per credentials block, each carrying
//               data-provider="shippo|ups|fedex"
//   envField  — provider-conditional field wrappers, each carrying
//               data-applies-when="ups,fedex" — a comma-separated list
//               of provider keys the field should be visible for.
//   submit    — the form's submit button; its label swaps per provider
//               (data-<provider>-label) so an OAuth carrier reads
//               "Add & connect to UPS" instead of a bare "Add Carrier".
export default class extends Controller {
    static targets = ["select", "section", "envField", "submit"]

    connect() {
        this.update()
    }

    update() {
        const current = (this.hasSelectTarget && this.selectTarget.value) || "shippo"

        // Credentials blocks: one section per provider.
        this.sectionTargets.forEach(section => {
            const matches = section.dataset.provider === current
            section.classList.toggle("hidden", !matches)
        })

        // Submit label: makes the connect-on-save intent explicit for
        // OAuth providers (the controller redirects them into sign-in).
        if (this.hasSubmitTarget) {
            const label = this.submitTarget.dataset[`${current}Label`]
            if (label) this.submitTarget.value = label
        }

        // Environment field (and any other provider-conditional fields)
        // declare which providers they apply to via data-applies-when.
        this.envFieldTargets.forEach(field => {
            const applies = (field.dataset.appliesWhen || "")
                .split(",")
                .map(s => s.trim())
                .filter(Boolean)
            field.style.display = applies.includes(current) ? "" : "none"
        })
    }
}
